import { PermissionsGate } from 'features/permissions'
import { SiteMapVizEditorPermissionsList } from 'features/siteMapViz'
import React, { FC } from 'react'
import { Vector2 } from 'three'
import { GeckoSiteModel, GeckoUnit } from 'types'

import { MapPlusMenuOverlayContainer } from './editMode/plusMenu/MapPlusMenuOverlayContainer'
import { MapPopupMenus } from './MapPopupMenus'

interface MapEditorOverlaysContainerProps {
  addMapFeatureMenuLocationRef:
    | React.RefObject<HTMLDivElement | null>
    | undefined
  siteModel: GeckoSiteModel
  allUnitsAtSite: ReadonlyArray<GeckoUnit>
}
export const MapEditorOverlaysContainer: FC<MapEditorOverlaysContainerProps> = (
  props
) => {
  const [showEditSiteConfigPopupMenu, setShowEditSiteConfigPopupMenu] =
    React.useState<Vector2 | undefined>(undefined)
  return (
    <PermissionsGate requires={SiteMapVizEditorPermissionsList}>
      <MapPlusMenuOverlayContainer
        divToPortalInto={props.addMapFeatureMenuLocationRef}
        setShowEditSiteConfigPopupMenu={setShowEditSiteConfigPopupMenu}
      />
      <MapPopupMenus
        siteModel={props.siteModel}
        allUnitsAtSite={props.allUnitsAtSite}
        showEditSiteConfigPopupMenu={showEditSiteConfigPopupMenu}
        setShowEditSiteConfigPopupMenu={setShowEditSiteConfigPopupMenu}
      />
    </PermissionsGate>
  )
}
